import { render } from "./main.vue?vue&type=template&id=6c5c7dd5&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=6c5c7dd5&scoped=true&lang=scss"

import exportComponent from "/Volumes/wangxiaochuan/personal/work/目睹复刻-博鳌/live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5c7dd5"]])

export default __exports__